"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = _interopRequireDefault(require("immutable"));

var StorefrontCollection = _interopRequireWildcard(require("../constants/StorefrontCollection"));

var _constants = require("../constants");

var initialState = _immutable.default.fromJS([{
  collection: StorefrontCollection.PIESYNC,
  showCallout: false,
  showResultsHeader: true
}, {
  collection: StorefrontCollection.CMS,
  showCallout: false,
  showResultsHeader: true
}, {
  collection: StorefrontCollection.ABM,
  showCallout: true,
  showResultsHeader: true
}, // TEMPORARY - NOT A COLLECTION
{
  collection: _constants.AMPLIFY_PARTNER_RELIEF,
  showCallout: true
}]); // TODO fetch from BE eventually?


var featuredCollections = function featuredCollections() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    default:
      return state;
  }
};

var _default = featuredCollections;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/reducers/featuredCollections.js
// module id = 639
// module chunks = 209 210 211 212